import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createWebSocketMiddleware from "./middleware/createWebSocketMiddleware";
// import { thunk } from "redux-thunk";

import sessionsReducer from "./reducers/sessionsReducer";
import salesReducer from "./reducers/salesReducer";

export const initialReducer = combineReducers({
  sessions: sessionsReducer, // Minimal setup
  sales: salesReducer, // Sales user state (no websocket)
});

const store = configureStore({
  reducer: initialReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      createWebSocketMiddleware("userSession"),
      createWebSocketMiddleware("notarySession"),
      createWebSocketMiddleware("guestSession"),
      createWebSocketMiddleware("subUserSession"),
      createWebSocketMiddleware("privateProviderSession")
      // thunk
    ),
});

export default store;
